import { Injectable } from '@angular/core';

import { WidgetsApiService } from '@main/widgets/shared/services/widgets.api-service';

@Injectable()
export class CategoriesWidgetsApiService extends WidgetsApiService {}
